import StudentGradeBook from './components/studentGB'
import InstructorGradeBook from './components/instructorGB'
import './styles.css'
import { useSelector, useDispatch } from 'react-redux'
import React, { useState, useEffect } from 'react'
import { getSummaryOfCourse } from '../../reducers/summaryGradebookReducer'
import { getSubsOfCourse } from '../../reducers/gradebookReducer'
import useCoursePrivilege from '../../hooks/useCourseprivilege'

const GradeBook = ({ courseId }) => {
  const { privilege } = useCoursePrivilege()
  const dispatch = useDispatch()

  const user = useSelector((state) => state.auth.user)

  useEffect(() => {
    dispatch(getSummaryOfCourse(courseId))
    if (privilege !== 'student') {
      dispatch(getSubsOfCourse(courseId))
    }
  }, [dispatch, courseId])

  return (
    <>  
      <h1 style={{
        fontSize: '24px',
        fontWeight: '600',
        marginBottom: '20px'
      }}>Gradebook</h1>
      {privilege === 'student' && (
        <StudentGradeBook courseId={courseId} id={user._id} />
      )}
      {privilege !== 'student' && (
        <InstructorGradeBook courseId={courseId} id={user._id} />
      )}
    </>
  )
}

export default GradeBook
